/**
 * @author Ivelin Ivanov
 */
var stBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailSalesTeamController = (function () {
    function DetailSalesTeamController(topic, settings, socket, env) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.env = env;
        this.visible = false;
    }
    ;
    DetailSalesTeamController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailSalesTeamController.prototype.displayOtherContatcs = function () {
        console.log('sending req for other contacts');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'showOtherContacts',
                script: '/detail/general/general',
                //data: this.topic.topic.gpp[0].opp,
                data: this.topic.getId(this.topic.topic._id),
                token: this.env.user.token,
                user: this.env.user.email,
                bID: this.topic.topicBrowserID
            }
        });
    };
    DetailSalesTeamController.$inject = ['topic', 'settings', 'socket', 'env'];
    return DetailSalesTeamController;
}());
var DetailSalesTeamComponent = (function () {
    function DetailSalesTeamComponent() {
        this.bindings = stBind;
        this.templateUrl = 'detail-sales-team.html';
        this.controller = DetailSalesTeamController;
    }
    return DetailSalesTeamComponent;
}());
angular
    .module('application')
    .component('detailSalesTeam', new DetailSalesTeamComponent());

//# sourceMappingURL=detail.general.st.component.js.map
